import API from "serviceshift-ui/api-client";

const PREFERENCE_URL = "/v3/admin_preferences";

export default {
  async fetchPreferences({ commit }) {
    const res = await API.makeRequest(PREFERENCE_URL, {
      method: "GET"
    });
    commit("replace", {
      state: "adminPreferences",
      data: res.data.admin_preferences
    });
    return res.data.admin_preferences;
  },

  async enablePreference(_, preference_key: string) {
    return await API.makeRequest(PREFERENCE_URL, {
      method: "POST",
      data: { preference_key }
    });
  },

  async disablePreference(_, preference_key: string) {
    return await API.makeRequest(`${PREFERENCE_URL}/${preference_key}`, {
      method: "DELETE"
    });
  }
};
